import React, { memo } from "react";
import { CMButton } from "@pscsrvlab/psc-react-components";
import { ComponentStyleProps } from "../../../../lib/styles/props/component-style-props";
import { useAppTranslation } from "../../../../hooks/use-app-translation";

export type EditEndButtonProps = {
  onClick?: () => void;
} & ComponentStyleProps;
export const EditEndButton = memo(function EditEndButton({
  onClick,

  sx,
  ...rest
}: EditEndButtonProps) {
  const { t } = useAppTranslation();
  return (
    <CMButton
      colorScheme={"gray"}
      size={"sm"}
      onClick={onClick}
      label={t("btn.編集終了ボタン")}
      sx={sx}
      {...rest}
    />
  );
});
